import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useCampaignQuoteTemplate, { useCampaignQuoteTemplateForm } from '@hooks/useCampaignQuoteTemplate'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'SaveQuoteAsTemplateModal'

type ModalCallbacks = {
  closeModal: () => void,
  createCampaignQuoteTemplateFromQuote: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const SaveQuoteAsTemplateModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, createCampaignQuoteTemplateFromQuote } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const {
    campaignQuoteId,
    campaignQuoteTemplate: initCampaignQuoteTemplate,
  } = modalPayload

  const {
    callbacks: { createCampaignQuoteTemplateFromQuote: createFn },
    creating,
  } = useCampaignQuoteTemplate(initCampaignQuoteTemplate)

  const {
    entityState,
    entityState: {
      title,
    },
    errors,
    handlers,
    saveEnabled,
  } = useCampaignQuoteTemplateForm(initCampaignQuoteTemplate, { validateOn: 'change' })

  const createCampaignQuoteTemplatePayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: {
      campaignQuoteId,
      campaignQuoteTemplate: {
        ...entityState,
      },
    },
    toastText: 'Quote Template Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Quote Template" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          // @ts-expect-error TS2345
          onClick={() => { createCampaignQuoteTemplateFromQuote(createCampaignQuoteTemplatePayload) }}
          size="large"
        >
          {saveEnabled ? 'Create Quote Template' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <SaveQuoteAsTemplateModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
